import { Injectable } from '@angular/core';
// import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslationService {
  
  _selected_lang: string = "en";
  _lang = {};
  translationObj: any;
  error: any;
  allLang = [];

  TranslationFileLoaded: boolean = false;

  constructor(private http: HttpClient) {}

  public use(lang: string): void {
      // set current language
      this._selected_lang = lang;
  }

  dataFile: any;

  // Load Data File
  public LoadDataFile() {

    if( this.TranslationFileLoaded == false ) {
      // var sheet_url = "https://sheets.googleapis.com/v4/spreadsheets/1PdKEqCZGfpfG0YmXqW1_N5dK_LPqWNCeOmFK6eMxj8w/values/Translations?key=AIzaSyCCVxv7pBGxI7kc0ughPUlugG5GSYGjpvo";
      var sheet_url = "/assets/translations.json?"+ Math.random();
      this.dataFile = this.http.get(sheet_url);
    }

    return this.dataFile;
  }

  // Subscribe to Results
  public getDataFile() {

      this.LoadDataFile().subscribe(
        data => this.translationObj = data.values,
        error => this.error = error,
        () => {
          this.TranslationFileLoaded = true;
          return this.createDict();
        }
      );
  }

  public createDict() {

      // Create Language List
      var allLang = this.translationObj[0];
      allLang.splice(0,1);
      this.createLangList(allLang);

      // Create Translation Object
      this._lang = {}
      for (var i = 0; i < this.translationObj.length; ++i) {

          if( i > 0 ) {
              var obj = this.translationObj[i];
              var key = obj[0];

              if( key != "" ) {
                  this._lang[key] = {}

                  for (var k = 0; k < this.allLang.length; ++k) {

                      if( this.allLang[k] != "" && obj[k+1] != "" ) {
                          var lang_slug = this.allLang[k][0];
                          var value = obj[k+1];

                          this._lang[key][lang_slug] = value;
                      }

                  }
              }
          }
      }

      // localStorage.setItem('translationData', JSON.stringify({
      //     "data": this._lang, 
      //     "selected_lang": this._selected_lang, 
      //     "timestamp": new Date().getTime()
      // }));

      // console.log("Dictionary Loaded");

      return this._lang;
  }

  private createLangList(allLang) {
    for (var k = 0; k < allLang.length; ++k) {
      var lang = allLang[k].split("|")
      this.allLang[k] = lang;
    }

    return this.allLang;
  }

  public getAllLang() {
    return this.allLang;
  }

  // already return a clone of the current state
  get state() {
    return this._lang = this._clone(this._lang);
  }
  // never allow mutation
  set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }


  get() {
    return this.state;
  }

  set(value: any) {
    return this._lang = value;
  }


  private _clone(object: Object) {
    // simple object clone
    return JSON.parse(JSON.stringify( object ));
  }


  public instant(key: string) {
      // call translation
      return this.translate(key); 
  }

  private translate(key: string): string {
      // private perform translation
      let translation = key;

      if (this._lang[key] && this._lang[key][this._selected_lang]) {
          return this._lang[key][this._selected_lang];
      }

      return translation;
  }

}
